<template>
  <div class="container-fluid main-container-fluid breadcrumb-layout">
    <archived-bar class="col-12 col-md-10 col-lg-10 ml-auto mr-auto" v-if="isArchived" />
    <page-header
      :org-id="orgId"
      :team-id="teamId"
      :show-new-goal-button="showNewGoalButton"
      :show-team-members="false"
      :selected-interval="selectedInterval"
      :show-back-button="visitedRoutes.length > 1"
      :lock-timeline="true"
      @back="goBack"
    />
    <div class="row justify-content-center page-content">
      <div class="col-12 col-md-10 col-lg-9 breadcrumb-container">
        <nav class="bc-nav">
          <b-breadcrumb>
            <b-breadcrumb-item
              v-for="(item, index) in breadCrumbItems"
              :key="index"
              :to="item.to"
              :title="item.text"
              :class="{ 'flex-shrink-0': index === 0, 'is-link': !!item.to }"
            >
              <span class="icon-wrapper" v-if="item.type">
                <i class="goal-icon" v-if="item.type === ENTITY_TYPE.GOAL"></i>
                <i class="kr-icon" v-else-if="item.type === ENTITY_TYPE.KEY_RESULT"></i>
                <initiative-icon v-else-if="item.type === ENTITY_TYPE.INITIATIVE"></initiative-icon>
                <i class="idea-list-icon" v-else-if="item.type === ENTITY_TYPE.IDEA_LIST"></i>
                <project-icon
                  class="project-icon flex-shrink-0 mr-1"
                  :color="item.color"
                  v-else-if="item.type === ENTITY_TYPE.PROJECT"
                />
              </span>
              <span v-no-capture>{{ item.text }}</span>
            </b-breadcrumb-item>
          </b-breadcrumb>
        </nav>
      </div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import InitiativeIcon from '@/components/initiative/InitiativeIcon'
import ProjectIcon from '@/components/project/ProjectIcon.vue'
import { ENTITY_TYPE } from '@/constants/entities'
import { BBreadcrumb, BBreadcrumbItem } from 'bootstrap-vue'
import { intervalWithId } from '../interval'
import InitiativesMixin from '@/mixins/InitiativesMixin'
import ArchivedBar from '@/components/ArchivedBar'
import PageHeader from '@/components/PageHeader'

export default {
  name: 'BreadcrumbLayout',
  components: {
    ProjectIcon,
    BBreadcrumb,
    BBreadcrumbItem,
    ArchivedBar,
    PageHeader,
    InitiativeIcon
  },
  props: [
    'orgId',
    'teamId',
    'breadCrumbItems',
    'isArchived',
    'timeline',
    'showNewGoalButton',
    'matchExactInterval'
  ],
  mixins: [InitiativesMixin],
  data() {
    return {
      ENTITY_TYPE
    }
  },
  computed: {
    visitedRoutes() {
      return this.$store.state.visitedRoutes
    },
    selectedInterval() {
      if (this.timeline) {
        return intervalWithId(this.timeline, { matchExact: this.matchExactInterval })
      } else {
        return null
      }
    }
  },
  methods: {
    goBack() {
      this.$emit('back')
      window.history.back()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/styleConfigurations';

.breadcrumb-layout {
  .bc-nav {
    margin: 0 6px;
    min-height: 64px;
    .breadcrumb {
      background-color: #fff;
    }
  }

  .bc-nav {
    box-shadow: $cardShadow;
    border-radius: 10px;
    overflow: hidden;
  }
}
.icon-wrapper {
  width: 15px;
  height: 15px;
  display: inline-flex;
  position: relative;
  .goal-icon {
    position: absolute;
    top: 2px;
  }
  .kr-icon {
    position: absolute;
    top: 4px;
  }
  .idea-list-icon {
    position: absolute;
    top: 3px;
    @include dimension(12px, 14px);
  }
}
/deep/ .breadcrumb-item a:hover {
  text-decoration: none;
}
/deep/ .breadcrumb {
  margin-bottom: 16px;
  flex-wrap: nowrap;
}
@include media-breakpoint-down(md) {
  .breadcrumb-layout .bc-nav {
    box-shadow: none;
    border-radius: 0;
  }
  .page-content {
    margin: 0;
  }
  .breadcrumb-container {
    padding: 0;
  }
  .bc-nav {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .breadcrumb {
    border-top: 1px solid $borderSecondary;
    border-bottom: 1px solid $borderSecondary;
    border-radius: 0;
    padding-left: 0px;
  }
}
/deep/ .breadcrumb-item {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  &:not(.is-link):last-child {
    flex: 1 0 100px;
    a[href='#'] {
      color: $secondary;
    }
  }
  &.is-link:last-child:last-of-type {
    flex: 1 0 200px;
  }
}
/deep/ .breadcrumb {
  margin-left: 0;
  margin-right: 0;
}
.hide {
  visibility: hidden;
}
.project-icon {
  transform: translateY(2px);
}
</style>
